module.exports = __webpack_public_path__ + "img/TH.bce9f16d.svg";